import { SortingDebtResult } from '@common/apis/sorting-debt/types';
import { ARC4U_IDENTIFIER } from '@libs/renegkit';
import { getPartnerImage } from '@libs/utils/helpers/getPartnerImage';
import * as magalu from '@dues/helpers/magalu';
import * as btg from './btg';
import { isArcIdentifier } from './btg';
import { SimulatedDebt } from '@common/apis/simulated-debt/types';
import { FormattedDebt } from '@common/contexts/DebtsContext/types';

export function getDebtLogo(debt: SortingDebtResult | FormattedDebt | SimulatedDebt) {
  // @ts-ignore
  const props = debt?.propriedades || debt?.properties || [];
  const shouldUseMagalu = magalu.getShouldUseMagaluBrandDebt(debt?.partner?.identifier || debt?.partner?.partnerIdentifier, debt);

  const isArc =
    props.some((prop: any) => prop.chave === 'ARC_DEBT' || prop.key === 'ARC_DEBT') ||
    isArcIdentifier(debt?.partner?.identifier) ||
    isArcIdentifier(debt?.partner?.partnerIdentifier);

  let usedIndentifier = debt?.partner?.identifier;

  if (shouldUseMagalu) usedIndentifier = 'magalu';
  if (isArc) usedIndentifier = ARC4U_IDENTIFIER;

  const partnerImage = getPartnerImage(usedIndentifier);
  return partnerImage;
}
